/* eslint-disable import/prefer-default-export */
import axios from 'axios'

const { RUTA_SEGURA_API } = process.env


const apiRutaSegura = axios.create({
  baseURL: RUTA_SEGURA_API,
  withCredentials: true,
  timeout: 960000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// apiAxioma.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status === 403) {
//       sessionStorage.setItem('userStatus', '')
//       window.location.href = '/'
//     }
//     return Promise.reject(error)
//   },
// )

export { apiRutaSegura }